export const PAGES = {
    randomizer: "randomizer",
    solarSystem: "solar-system",
    bubbles: "bubbles",
    rainbowPetals: "iris",
    stairway: "stairway",
    bananaScale: "banana-scale",
};
